import { combineReducers } from "redux";

import language from "./_language";
import language_list from "./_languages";
import fetching from "./_fetching";

export default combineReducers({ language, language_list, fetching });
